import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import CreateMeme from './submodules/create';
import ListMeme from './submodules/list';
import UpdateMeme from './submodules/edit';
import CloneMeme from './submodules/clone/Clone';

const MemesDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.social}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.social].getAllMemePosts]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListMeme}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.social}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.social].createNewMemePost]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/clone`}
				component={CloneMeme}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.social}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.social].createNewMemePost]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateMeme}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.social}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.social].updateMemePost]}
				path={`${path}/edit`}
				configPageName={PAGE_NAMES.dashboard}
				component={UpdateMeme}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default MemesDashboard;
